module.exports = __webpack_public_path__ + "img/rocket.0a09a499.svg";